module.exports = __webpack_public_path__ + "img/na.c5e062fc.svg";